import { IntlProvider, injectIntl } from 'react-intl';
import React from 'react';
import merge from 'lodash.merge';
import localeBaurde from './locales/baurde';
import localeImwalkingde from './locales/imwalkingde';
import localeQuellede from './locales/quellede';
import localeQuellech from './locales/quellech';
import localeQuelleat from './locales/quelleat';
import localeOttoversandat from './locales/ottoversandat';
import localeUniversalat from './locales/universalat';
import localeAckermannch from './locales/ackermannch';
import localeJelmolich from './locales/jelmolich';
import localeDefault from './locales/default';
var tenantLocales = {
    baurde: localeBaurde,
    imwalkingde: localeImwalkingde,
    quellede: localeQuellede,
    quellech: localeQuellech,
    quelleat: localeQuelleat,
    ottoversandat: localeOttoversandat,
    universalat: localeUniversalat,
    ackermannch: localeAckermannch,
    jelmolich: localeJelmolich,
    emma: localeDefault,
};
export var Provider = function (_a) {
    var intl = _a.intl, children = _a.children, companyId = _a.companyId;
    var locale = intl.locale, messages = intl.messages;
    var tenantLocale = tenantLocales["" + companyId] || {};
    var providerMessages = merge(messages, tenantLocale["" + locale] || {});
    return (React.createElement(IntlProvider, { defaultLocale: "en", key: intl.locale, locale: intl.locale, messages: providerMessages }, children));
};
export default injectIntl(Provider);
//# sourceMappingURL=index.js.map